import React, { useEffect, useState } from "react";
import closedCaption from "./../../assets/closedCaption.svg";
import webAudit from "./../../assets/webAudit.svg";
import apt from "./.././../assets/apt.svg";
import autoEval from "./../../assets/apt.svg";
import identityManagement from "./../../assets/code_crafter.svg";
import ccValidator from "./../../assets/ccValidator.svg";
import automatedCrawler from "./../../assets/automatedCrawler.svg";
import healthDashboard from "./../../assets/healthDashboard.svg";
import aiAutoEval from "./../../assets/aiautoeval.svg";
import loginIcon from "./../../assets/magicedtech.svg";
import { useNavigate } from "react-router-dom";
import styles from "./home.module.css";
import backgroundBg from "./../../assets/background_page.svg";
import Cookies from "js-cookie";
import logo from "./../../assets/logo.svg";
import backgroundAI from "./../../assets/home_bg.svg";
import userIcon from "./../../assets/user_icon.svg";
import { getCookie } from "../../commonUtils";
import PopupHealthDashboard from "./PopupHealthDashboard";
import { clearAllCookies } from "../../utils";
/*istanbul ignore next*/
export const getAssessmentEngineUrl = (userDetails) => {
  if (userDetails && userDetails.userRole === "SUP_PUBLISHER") {
    return "admin/#/";
  }
  return "#";
};

/*istanbul ignore next*/
const Home = ({ user }) => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupType, setPopupType] = useState(null);
  const savedUser = getCookie("username");
  const email = getCookie("email");
  const token = getCookie("authToken");
  console.log('magically token <>', token);
  const userDetails = getCookie("User");
  let userRole = "";
  if (userDetails) {
    const userData = JSON.parse(userDetails);
    userRole = userData["roleId"] ?? userData["userRole"] ?? null;
  }

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const currentYear = new Date().getFullYear();

  const handleLogout = () => {
    clearAllCookies();
    navigate('/', { replace: true });
  };

  useEffect(() => {
    // Save current body styles to restore later
    const originalBodyStyle = document.body.style.cssText;

    // Apply your module-specific styles
    document.body.style.fontFamily = "Oswald, sans-serif";
    document.body.style.margin = "0";
    document.body.style.fontWeight = "700";
    document.body.style.padding = "20px 40px";
    document.body.style.background = `linear-gradient(180deg, #F7F4FF 9.98%, #F1F6F9 100%)`;
    // document.body.style.backgroundImage = `url(${backgroundAI}), linear-gradient(
    //       #220E40 0%, 
    //       #220E3F 0%, 
    //       #24255E 0%, 
    //       #243166 0%
    //     )`;
    // document.body.style.backgroundSize = "cover";
    // document.body.style.backgroundColor = "#18174c";
    // document.body.style.backgroundPositionY = "0";
    // document.body.style.backgroundPositionX = "-62px";

    return () => {
      document.body.style.cssText = originalBodyStyle;
    };
  }, []);

  const openPopup = (type) => {
    setPopupType(type);
    setIsPopupOpen(true);
  };
  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupType(null);
  };

  return (
    <>
      <div className={styles.mainContainer}>
        <div className="login-header">
          <div className="logo">
            <img src={logo} alt="Accelerators" />
          </div>
          <div className="user-dropdown">
            <img src={userIcon} onClick={toggleDropdown} />
            {/* <button >{savedUser} ▼</button> */}
            {dropdownOpen && (
              <div className="dropdown-menu">
                <div>
                  {savedUser}
                  <span>{email}</span>
                </div>
                <button className="logout-button" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
        {/* <header>
          <img src={loginIcon} alt="Logo" id="logo"/>

      </header> */}
        <h1 className={styles.subHeader}>MagicA11y</h1>
        <h2>
          We are committed to humanity’s pursuit of happiness by making lifelong
          digital learning accessible, affordable and sustainable.
        </h2>
        <main>
          <div className={styles.tiles}>
            {userRole !== "CONTRACTOR" ? (
              <>
                <a
                  target="_blank"
                  href="https://magica11y.magicedtech.ai/"
                  className={styles.tile}
                  data-testid="assessment-engine-link"
                >
                  <img src={automatedCrawler} alt="Health Dashboard" />
                  <div>
                    A11y Remediation Processes
                  </div>
                </a>
                <a
                  target="_blank"
                  href="https://cc.magicedtech.com/"
                  className={styles.tile}
                  data-testid="assessment-engine-link"
                >
                  <img src={closedCaption} alt="Closed Captions" />
                  <div>
                    Closed <br />
                    Captions
                  </div>
                </a>
                <a
                  target="_blank"
                  href="https://ccv.magicedtech.com/"
                  className={styles.tile}
                >
                  <img src={ccValidator} alt="Color Contrast Validator" />
                  <div>
                    Color Contrast <br />
                    Validator
                  </div>
                </a>
                <a
                  target="_blank"
                  href="https://webaudit.magicedtech.com/"
                  className={styles.tile}
                >
                  <img src={webAudit} alt="Web Audit" />
                  <div>
                    Web <br />
                    Audit
                  </div>
                </a>
                <a
                  target="_blank"
                  href={`https://hdashboard.magicedtech.com/?token=${token}`}
                  className={styles.tile}
                >
                  <img src={healthDashboard} alt="Health Dashboard" />
                  <div>
                    Health <br />
                    Dashboard
                  </div>
                </a>
              </>
            ) : null}

            <div onClick={() => openPopup("pearson")} className={styles.tile} role="button" tabIndex={0}>
              <img src={healthDashboard} alt="Health Dashboard" />
              <div>
                Health <br />
                Dashboard <p className={styles.smallText}>(Pearson HigherEd)</p>
              </div>
            </div>

            <a
              target="_blank"
              href={`https://pearsonabr.magicedtech.com/?token=${token}`}
              className={styles.tile}
            >
              <img src={healthDashboard} alt="Health Dashboard" />
              <div>
                Health <br />
                Dashboard{" "}
                <p className={styles.smallText}>(Pearson PVS)</p>
              </div>
            </a>

            <a
              target="_blank"
              href={`https://hdashboardMHEEZAssessments.magicedtech.com/?token=${token}`}
              className={styles.tile}
            >
              <img src={healthDashboard} alt="Health Dashboard" />
              <div>
                Health <br />
                Dashboard{" "}
                <p className={styles.smallText}>(McGraw EZ-Assessment)</p>
              </div>
            </a>
            <a
              target="_blank"
              href={`https://hdashboardMHEeBooksQA.magicedtech.com/?token=${token}`}
              className={styles.tile}
            >
              <img src={healthDashboard} alt="Health Dashboard" />
              <div>
                Health <br />
                Dashboard <p className={styles.smallText}>(McGraw eBooks)</p>
              </div>
            </a>
            <div
              onClick={() => openPopup("hmh")}
              className={styles.tile}
              role="button"
              tabIndex={0}
            >
              <img src={healthDashboard} alt="Health Dashboard" />
              <div>
                Health <br />
                Dashboard <p className={styles.smallText}>(HMH)</p>
              </div>
            </div>

            <a
              target="_blank"
              href={`https://edmentum.magicedtech.com/?token=${token}`}
              className={styles.tile}
            >
              <img src={healthDashboard} alt="Health Dashboard" />
              <div>
                Health <br />
                Dashboard <p className={styles.smallText}>(Edmentum)</p>
              </div>
            </a>

          </div>
        </main>
        <footer>
          <div className="left-footer"></div>
          <div>&copy; {currentYear} Magic Software Inc. All rights reserved.</div>
        </footer>
      </div>
      {/* Popup/Modal */}
      {isPopupOpen && popupType && (
        <PopupHealthDashboard
          closePopup={closePopup}
          token={token}
          popupType={popupType}
        />
      )}
    </>
  );
};

export default Home;
